import { useRouteLoaderData } from 'react-router';

import type { ApiEmbedSearchWidget } from 'modules/embedSearchWidget/api/types/ApiEmbedSearchWidget';

export function useEmbedSearchWidgetLayoutRouteLoaderData() {
  const loaderData = useRouteLoaderData<{
    embedSearchWidget: ApiEmbedSearchWidget;
  }>('embed-search-widget-layout');

  const { embedSearchWidget } = loaderData ?? {};

  return { embedSearchWidgetSearchLocation: embedSearchWidget?.location };
}
